import { Component, ElementRef, HostListener, OnInit, ViewChild, ChangeDetectorRef, ChangeDetectionStrategy, TemplateRef, inject, WritableSignal, signal } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { AdminService } from 'src/app/services/admin/admin.service';
import { faApple, faGoogle, faMicrosoft } from '@fortawesome/free-brands-svg-icons'
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-sign-in',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule
  ],
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignInComponent implements OnInit {
  deferredPrompt: any = null;
  isInstalled = false;

  validateForm!: FormGroup;

  faApple = faApple
  faGoogle = faGoogle
  faMicrosoft = faMicrosoft
 

  constructor(
    private fb: FormBuilder,
    public admin: AdminService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {}


  ngOnInit(): void {
    if (this.admin.isAdmin()) {
      this.router.navigate(['']);
    }

    this.validateForm = this.fb.group({
      user: [null, [Validators.required]],
      password: [null, [Validators.required]]
    });

    const installBtn = document.getElementById('installBtn');

    // iOS detection (Safari)
    const isIOS = /iphone|ipad|ipod/i.test(window.navigator.userAgent);

    // უკვე დაინსტალირებულია თუ არა (Android + iOS)
    this.isInstalled =
      window.matchMedia('(display-mode: standalone)').matches ||
      (window.navigator as any).standalone === true;

    // თუ უკვე დაინსტალირებულია — ღილაკი დამალე
    if (installBtn && this.isInstalled) {
      installBtn.hidden = true;
    }

    // ✅ iPhone / Safari — სანამ არ არის დაინსტალირებული, ღილაკი ყოველთვის გამოჩნდეს
    if (installBtn && isIOS && !this.isInstalled) {
      installBtn.hidden = false;
    }

    // ✅ Android / Chrome install event
    window.addEventListener('beforeinstallprompt', (e: any) => {
      e.preventDefault();
      this.deferredPrompt = e;

      if (installBtn && !this.isInstalled) {
        installBtn.hidden = false;
      }
    });

    // ✅ როდესაც აპი რეალურად დაინსტალირდება
    window.addEventListener('appinstalled', () => {
      this.isInstalled = true;
      if (installBtn) {
        installBtn.hidden = true;
      }
    });
  }

  submitForm(): void {
    for (const i in this.validateForm.controls) {
      if (this.validateForm.controls.hasOwnProperty(i)) {
        this.validateForm.controls[i].markAsDirty();
        this.validateForm.controls[i].updateValueAndValidity();
      }
    }
  
    const data = {
      user: this.validateForm.value.user,
      password: this.validateForm.value.password
    };
  
    if (!this.admin.isAdmin()) {
      this.admin.login(data)
        .then((isSuccess) => {
          if (isSuccess) {
            // წარმატებული ავტორიზაცია
            // მაგალითად, შეგიძლიათ აქ დაამატოთ სხვა ლოგიკა
            this.router.navigate(['/menu']);
          }
        })
        .catch((error) => {
          // შეცდომის დამუშავება
          console.log('Login error:', error);
        })
        .finally(() => {
          this.admin.loading = false;
          this.cdr.detectChanges(); // UI-ს განახლება, რათა Angular იცოდეს, რომ loading შეიცვალა
        });
    }
  }

  installApp() {
    if (!this.deferredPrompt) {
      // iOS-ზე ინსტალაცია მხოლოდ Share → Add to Home Screen-ით ხდება
      alert('iPhone-ზე ინსტალაციისთვის გამოიყენეთ: Share → Add to Home Screen');
      return;
    }

    this.deferredPrompt.prompt();

    this.deferredPrompt.userChoice.then((choiceResult: any) => {
      if (choiceResult.outcome === 'accepted') {
        const btn = document.getElementById('installBtn');
        if (btn) {
          btn.hidden = true;
        }
      }

      this.deferredPrompt = null;
    });
  }




 




}